<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [transparentOverlay]="true"
  >
  @if (rootDataView) {
    <div class="lm-drill-around-breadcrumb-container">
      <button
        #menuTrigger
        id="lm-drill-around-toggle-navigation-button"
        data-automation-id="lm-drill-around-toggle-navigation-button"
        [ngStyle]="{'vertical-align': 'middle', 'padding': '0px'}"
        class="btn-icon application-menu-trigger"
        type="button"
        soho-tooltip content="{{ 'ToggleDrillNavigationMenu' | translate }}"
        (click)="onToggleNavigation($event)">
        <span class="audible">{{ 'ToggleDrillNavigationMenu' | translate }}</span>
        <svg soho-icon [icon]="'bullet-steps'"></svg>
      </button>
      <ids-breadcrumb #IdsBreadcrumb color-variant="breadcrumb" truncate="true">
        @for (breadCrumbItem of breadCrumbList; track breadCrumbItem) {
          <ids-hyperlink tabindex="0" font-size="14" color-variant="breadcrumb" [attr.target-id]="breadCrumbItem.id" text-decoration="hover">{{breadCrumbItem.content}}</ids-hyperlink>
        }
      </ids-breadcrumb>
    </div>
    <div class="page-container">
      <ids-splitter #IdsSplitter>
        <!--size="{{splitterPosition}}"-->
        <ids-splitter-pane size="30%" [collapsed]="collapsed" id="lm-drill-splitter-left">
          <ids-layout-grid margin="xs">
            <ids-layout-grid-cell>
              <lm-drill-navigation
                [rootDataView]="rootDataView"
                [rootDrillActions]="rootDrillActions"
                (selected)="onNavigationNodeSelected($event)"
              ></lm-drill-navigation>
            </ids-layout-grid-cell>
          </ids-layout-grid>
          <!--<div class="scrollable" [@navigationVisibility]="showingNavigation ? 'visible' : 'hidden'">-->
        <!--</div>-->
      </ids-splitter-pane>
      <ids-splitter-pane id="lm-drill-splitter-right" style="overflow: hidden">
        <div #detailsContainer tabindex="-1">
          <div #DRILL_AROUND_VIEW_CONTAINER>
          <!--<ng-container *ngIf="drillAroundViewInfo && !experimentalComponentReuse">-->
          @if (drillAroundViewInfo) {
            <lm-drill-point-view #DRILL_AROUND_VIEW
              [info]="drillAroundViewInfo"
              [selectedNode]="selectedDrillAroundNode"
              (drillActionSelectedEvent)="onViewDrillPointSelected($event)"
              (drillAroundEvent)="onDrillAroundEvent($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)">
            </lm-drill-point-view>
          }
        <!--</ng-container>-->
        </div>
      </div>
    </ids-splitter-pane>
  </ids-splitter>
</div>
}
</div>
